// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal-module--backdrop--1mC6R","backdropImg":"modal-module--backdrop-img--2oxdB","closeBtn":"modal-module--closeBtn--EokfY"};